import React, { useEffect, useState } from 'react'
import '../Css/Umang.css';

import linkdin from "../Image/linkdin.svg";
import google from "../Image/google.svg";
import facebook from "../Image/facebook.svg";
import instagram from "../Image/instagram.svg";
import youtube from "../Image/Youtube-Header.svg";
import call from "../Image/call.svg";
import logo from "../Image/logo.png";
import Services from "../Image/Services.svg"
import hederMenu from '../Image/header-menu.svg'
import { TiThMenu } from "react-icons/ti";
import { IoClose } from "react-icons/io5";
import { FaHome } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { Link, useLocation } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { MdAddCall } from "react-icons/md";

const Header = () => {
  const path = useLocation();
  // console.log("Savani", path.pathname);

  const [isOpen, setIsOpen] = useState(false);
  const [isServiceOpen, setIsServiceOpen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) setIsOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const webIcons = [
    {
      image: linkdin,
      link: "https://www.linkedin.com/company/kalathiyainfotech/"
    },
    {
      image: google,
      link: "https://www.google.com/search?q=kalathiya+infotech&rlz=1C1GCEA_enIN1018IN1018&oq=Kalathiya+&aqs=chrome.0.69i59l2j69i57j69i59j69i60l4.17467j0j7&sourceid=chrome&ie=UTF-8"
    },
    {
      image: facebook,
      link: "https://www.facebook.com/kalathiyainfotech"
    },
    {
      image: instagram,
      link: "https://www.instagram.com/kalathiya_infotech/"
    },
    {
      image: youtube,
      link: "https://www.youtube.com/@KalathiyaInfotech"
    }
  ]

  const [isServiceMenuOpen, setIsServiceMenuOpen] = useState(false);
  return (
    <div className='sticky w-full bg-white top-0 z-50 shadow-md'>
      <header className="bg-header_bg w-full hidden sm:block">
        <div className='container'>
          <div className="bg-theme_dark flex flex-col sm:flex-row justify-between items-center text-white py-3 px-4">
            <a href="mailto:Info@kalathiyainfotech.com" className="text-sm font-medium mb-2 sm:mb-0 hover:underline">Info@kalathiyainfotech.com</a>
            <div className="flex items-center space-x-4">
              {webIcons?.map((icon, i) => (
                <a key={i} href={icon?.link} className="hover:text-purple-200 transition duration-200" target='_blank' rel="noreferrer"><img src={icon?.image} alt="social" className="w-4 h-4 sm:w-5 sm:h-5" /></a>
              ))}
            </div>
          </div>
        </div>
      </header>
      <header className="container w-full flex items-center justify-between flex-wrap md:py-0 py-4">
        <Link to="/" onClick={() => { setIsServiceMenuOpen(false) }}>
          <div className="md:mb-0"><img className="w-40 sm:w-50" src={logo} alt="Logo" /></div>
        </Link>
        <nav className="hidden md:flex flex-wrap justify-center gap-6 text-sm font-medium">
          <Link to="/" onClick={() => { setIsServiceMenuOpen(false) }} className={`nav-underline ${path?.pathname === "/" ? "nav_active" : ""}  py-7 text-sm font-medium`}>Home</Link>
          <Link to="/about" onClick={() => { setIsServiceMenuOpen(false) }} className={`nav-underline  ${path?.pathname === "/about" ? "nav_active" : ""} py-7 text-sm font-medium`}>About Us</Link>
          <div className={`relative py-7 nav-underline ${path?.pathname.includes('/service') ? "nav_active" : ""}`}>
            <div
              onClick={() => setIsServiceMenuOpen((prev) => !prev)}
              className="cursor-pointer text-sm font-medium"
            >
              Services
            </div>

            {isServiceMenuOpen && (
              <div className="absolute left-1/2 -translate-x-1/2 top-full z-50 w-[90vw] max-w-2xl flex justify-center">
                <div className="bg-white p-6 rounded-lg shadow-xl w-full flex flex-col md:flex-row items-center gap-8 border border-gray-200">
                  <div className="w-full md:w-1/2 flex justify-center">
                    <img src={hederMenu} alt="Development Illustration" className="max-w-xs object-contain" />
                  </div>
                  <div className="w-full md:w-1/2 flex items-start">
                    <div className="w-1 h-full border-l-4 border-pink-500 mr-6"></div>
                    <ul className="space-y-3 text-gray-800 text-base md:text-lg font-medium">
                      <li className={`hover:text-purple-600 cursor-pointer transition ${path?.pathname === "/service/web" ? "text-theme_dark" : ""}`}><Link onClick={() => { setIsServiceMenuOpen(false) }} to={'/service/web'}>Web Development</Link></li>
                      <li className={`hover:text-purple-600 cursor-pointer transition ${path?.pathname === "/service/mobile" ? "text-theme_dark" : ""}`}><Link onClick={() => { setIsServiceMenuOpen(false) }} to={'/service/mobile'}>Mobile App Development</Link></li>
                      <li className={`hover:text-purple-600 cursor-pointer transition ${path?.pathname === "/service/seo" ? "text-theme_dark" : ""}`}><Link onClick={() => { setIsServiceMenuOpen(false) }} to={'/service/seo'}>Search Engine Optimization</Link></li>
                      <li className={`hover:text-purple-600 cursor-pointer transition ${path?.pathname === "/service/design" ? "text-theme_dark" : ""}`}><Link onClick={() => { setIsServiceMenuOpen(false) }} to={'/service/design'}>UI/UX Design</Link></li>
                      <li className={`hover:text-purple-600 cursor-pointer transition ${path?.pathname === "/service/responsiveDesign" ? "text-theme_dark" : ""}`}><Link onClick={() => { setIsServiceMenuOpen(false) }} to={'/service/responsiveDesign'}>Responsive Web Design</Link></li>
                      <li className={`hover:text-purple-600 cursor-pointer transition ${path?.pathname === "/service/fullStack" ? "text-theme_dark" : ""}`}><Link onClick={() => { setIsServiceMenuOpen(false) }} to={'/service/fullStack'}>Full Stack Development</Link></li>
                      <li className={`hover:text-purple-600 cursor-pointer transition ${path?.pathname === "/service/digitalMarketing" ? "text-theme_dark" : ""}`}><Link onClick={() => { setIsServiceMenuOpen(false) }} to={'/service/digitalMarketing'}>Digital Marketing</Link></li>
                      <li className={`hover:text-purple-600 cursor-pointer transition ${path?.pathname === "/service/reactNative" ? "text-theme_dark" : ""}`}><Link onClick={() => { setIsServiceMenuOpen(false) }} to={'/service/reactNative'}>React Native</Link></li>
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>
          <Link to="/contact" onClick={() => { setIsServiceMenuOpen(false) }} className={`nav-underline py-7 text-sm font-medium ${path?.pathname === "/contact" ? "nav_active" : ""}`}>Contact Us</Link>
        </nav>
        <div className="flex items-center gap-4">
          <div className="sm:flex items-center gap-2 text-sm font-medium hidden sm:block">
            <img src={call} alt="Call" className="w-4 h-4" />
            <a href="tel:+91 93288 81036" >
              <span className="text-black whitespace-nowrap">+91 93288 81036</span>
            </a>
          </div>
          <button onClick={() => setIsOpen(true)} className="text-2xl md:hidden focus:outline-none" aria-label="Open menu"><TiThMenu /></button>
        </div>
      </header>

      {isOpen && (<div className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden" onClick={() => setIsOpen(false)} />)}

      {/* Offcanvas */}
      <div className={`fixed top-0 left-0 z-50 h-screen p-4 w-72 bg-white transition-transform duration-300 ${isOpen ? "translate-x-0" : "-translate-x-full"} md:hidden`}>
        <div className="flex justify-between items-center mb-4">
          <Link to="/" onClick={() => setIsOpen(false)}>
            <h5 className="text-base font-semibold uppercase"><img src={logo} alt="" className='w-40' /></h5>
          </Link>
          <button onClick={() => setIsOpen(false)} className=" hover:text-gray-900 rounded-lg w-8 h-8 flex items-center justify-center" aria-label="Close menu"><IoClose className="w-6 h-6" />
          </button>
        </div>
        <ul className="space-y-2 font-medium">
          <li>
            <button href="#" className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group" onClick={() => setIsOpen(false)}>
              <FaHome className='text-xl' />
              <span className="ms-3"><Link to="/" className={`${path?.pathname === "/" ? "nav_active" : ""}`}>Home</Link></span>
            </button>
          </li>
          <li>
            <button href="#" className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group" onClick={() => setIsOpen(false)}>
              <FaUser className='text-xl' />
              <span className="ms-3"><Link to="/about" className={`${path?.pathname === "/about" ? "nav_active" : ""}`}>About Us</Link></span>
            </button>
          </li>
          <li>
            <button className="flex items-center w-full p-2 text-gray-900 rounded-lg hover:bg-gray-100 group focus:outline-none" onClick={() => setIsServiceOpen((prev) => !prev)}>
              <img src={Services} alt="Services" className="w-5 h-5" />
              <span className="ms-3 flex-1 text-left">Services</span>
              {isServiceOpen ? <FaChevronUp className="ml-auto" /> : <FaChevronDown className="ml-auto" />}
            </button>
            {isServiceOpen && (
              <ul className="pl-8 mt-2 space-y-2 text-gray-700 text-sm">
                <li><Link to={'/service/web'} className={`block py-1 hover:text-purple-600 ${path?.pathname === "/service/web" ? "text-theme_dark" : ""}`} onClick={() => setIsOpen(false)}>Web Development</Link></li>
                <li><Link to={'/service/mobile'} className={`block py-1 hover:text-purple-600 ${path?.pathname === "/service/mobile" ? "text-theme_dark" : ""}`} onClick={() => setIsOpen(false)}>Mobile App Development</Link></li>
                <li><Link to={'/service/seo'} className={`block py-1 hover:text-purple-600 ${path?.pathname === "/service/seo" ? "text-theme_dark" : ""}`} onClick={() => setIsOpen(false)}>Search Engine Optimization</Link></li>
                <li><Link to={'/service/design'} className={`block py-1 hover:text-purple-600 ${path?.pathname === "/service/design" ? "text-theme_dark" : ""}`} onClick={() => setIsOpen(false)}>UI/UX Design</Link></li>
                <li><Link to={'/service/responsiveDesign'} className={`block py-1 hover:text-purple-600 ${path?.pathname === "/service/responsiveDesign" ? "text-theme_dark" : ""}`} onClick={() => setIsOpen(false)}>Responsive Web Design</Link></li>
                <li><Link to={'/service/fullStack'} className={`block py-1 hover:text-purple-600 ${path?.pathname === "/service/fullStack" ? "text-theme_dark" : ""}`} onClick={() => setIsOpen(false)}>Full Stack Development</Link></li>
                <li><Link to={'/service/digitalMarketing'} className={`block py-1 hover:text-purple-600 ${path?.pathname === "/service/digitalMarketing" ? "text-theme_dark" : ""}`} onClick={() => setIsOpen(false)}>Digital Marketing</Link></li>
                <li><Link to={'/service/reactNative'} className={`block py-1 hover:text-purple-600 ${path?.pathname === "/service/reactNative" ? "text-theme_dark" : ""}`} onClick={() => setIsOpen(false)}>React Native</Link></li>
              </ul>
            )}
          </li>
          <li>
            <button href="#" className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group" onClick={() => setIsOpen(false)}>
              <MdAddCall className='w-6 h-6' />
              <span className="ms-3"><Link to="/contact" className={`${path?.pathname === "/contact" ? "nav_active" : ""}`}>Contact Us</Link></span>
            </button>
          </li>
          <li>
            <button href="#" className="flex items-center p-2 text-gray-900 rounded-lg hover:bg-gray-100 group" onClick={() => setIsOpen(false)}>
              <div className="flex items-center gap-2 text-sm font-medium">
                <img src={call} alt="Call" className="w-5 h-5" />
                <a href="tel:+91 93288 81036" >
                  <span className="whitespace-nowrap">+91 93288 81036</span>
                </a>

              </div>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Header
